import React from "react";
import { BookOpenCheckIcon, GiftIcon } from "lucide-react";
type SpecialVolume = {
  number: string;
  title: string;
  description: string;
  image: string;
};
const specialVolumes: SpecialVolume[] = [{
  number: "TOMO SPECIALE 01",
  title: "Il sistema completo dei passaggi",
  description: "Linee di passaggio, tempi di gioco e soluzioni per far progredire la squadra.",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/882e43d9-8041-4428-9303-24ee9d249c63.jpg"
}, {
  number: "TOMO SPECIALE 02",
  title: "Velocità del mediano",
  description: "Accelerazione, cambi di direzione e letture per arrivare prima alla giocata.",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/3c55186e-1e91-488b-ab0c-c39ae1b2aa6e.jpg"
}];
type SpecialVolumesProps = {
  href: string;
};
export function SpecialVolumes({
  href
}: SpecialVolumesProps) {
  return <section className="border-y border-lime-300/20 py-10" data-id="element-152" data-mp="1i1ro4ks9qjup">
      <div className="rounded-3xl border border-lime-300/35 bg-lime-300/10 p-5 text-center" data-id="element-153" data-mp="2ddjkmz3983sz">
        <GiftIcon className="mx-auto h-7 w-7 text-lime-300" data-id="element-154" data-mp="2icmj20oqbbrz" />
        <p className="mt-3 text-xs font-black uppercase tracking-[0.18em] text-lime-300" data-id="element-155" data-mp="2id4jzamc6e68">
          Aspetta!
        </p>
        <h2 className="mt-2 text-3xl font-black uppercase italic leading-none text-white" data-id="element-156" data-mp="2n9mrgi91wqm9">
          Sappiamo che non è così semplice giocare da mediano.
        </h2>
        <p className="mt-3 text-sm leading-6 text-slate-200" data-id="element-157" data-mp="2w3833spx5rrg">
          Per questo oggi ricevi anche questi 2 tomi speciali, inclusi nel tuo accesso.
        </p>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3" data-id="element-158" data-mp="361xlrnpn3g8r">
        {specialVolumes.map(volume => <a key={volume.title} href={href} className="group overflow-hidden rounded-2xl border border-white/10 bg-black/45 focus:outline-none focus:ring-4 focus:ring-lime-300/50" data-id="element-159" data-mp="3b1jzrzdal0im">
            <img src={volume.image} alt={volume.title} className="aspect-[4/3] w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" data-id="element-160" data-mp="1gnstn9u68yrx" />
            <div className="p-3" data-id="element-161" data-mp="13pb71cbl12dl">
              <p className="text-[10px] font-black uppercase tracking-wide text-lime-300" data-id="element-162" data-mp="1ikhfs722bfam">{volume.number}</p>
              <h3 className="mt-1 text-sm font-black leading-4 text-white" data-id="element-163" data-mp="1dl4u3pmxge9m">{volume.title}</h3>
              <p className="mt-2 text-xs leading-4 text-slate-400" data-id="element-164" data-mp="1rl5uz536zlp3">{volume.description}</p>
              <p className="mt-3 flex items-center gap-1.5 text-[11px] font-bold text-lime-200" data-id="element-165" data-mp="1mmci9evqbypz"><BookOpenCheckIcon className="h-3.5 w-3.5" data-id="element-166" data-mp="1mki4ckivl6ve" /> Incluso oggi</p>
            </div>
          </a>)}
      </div>
    </section>;
}